import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import firebase from "../firebase";
import * as routes from "../constants/routes";

function checkNavigationStatusOffline(props) {
  const { authUser, history } = props;

  if (authUser) {
    history.push(routes.HOME);
  }
}

async function checkNavigationStatus(props) {
  const { authUser, history } = props;

  try {
    if (authUser) {
      authUser.getIdToken().then(idToken => {
        if (idToken) {
          history.push(routes.HOME);
        } else {
          console.log(
            "checkNavigationStatus -> auto login failed - no idToken from Firebase: "
          );
          handleSignOut(props);
        }
      });
    } else {
      console.log("checkNavigationStatus -> User not available in context");
      handleSignOut(props);
    }
  } catch (error) {
    console.log("checkNavigationStatus -> error: ", JSON.stringify(error));
  }
}

const Navigate = props => {
  if (navigator.onLine) {
    checkNavigationStatus(props);
  } else {
    checkNavigationStatusOffline(props);
  }

  return null;
};

const handleSignOut = props => {
  const { history } = props;
  const auth = firebase.auth();
  auth.doSignOut().then(
    () => {
      localStorage.clear();
      history.push(routes.LOGIN);
    },
    error => console.log("AutoLogin -> Error signing out", error)
  );
};

class AutoLogin extends Component {
  constructor(props) {
    super(props);
    this.beenThere = false;

    this.state = {};
  }

  render() {
    const { authUser, history } = this.props;
    //console.log("AutoLogin -> render -> authUser.uid: ", authUser.uid);

    this.beenThere = true;
    return (
      <div>
        {authUser ? <Navigate authUser={authUser} history={history} /> : null}
      </div>
    );
  }
}

export default withRouter(AutoLogin);
